import { TaskFilters } from './task-filters.model';

export class TaskSavedFilter extends TaskFilters {
  id?: number;
  name?: string;
}
